import script from "./PostHead.vue?vue&type=script&setup=true&lang=js"
export * from "./PostHead.vue?vue&type=script&setup=true&lang=js"

import "./PostHead.vue?vue&type=style&index=0&id=62c8ed24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c8ed24"]])

export default __exports__